export default "__VITE_ASSET__BV__1IBO__"